import { RouteWidgetParams } from '../../types';

export const checkIsAlternativeVariantsChanged = (
  currentParams: RouteWidgetParams,
  defaultParams: RouteWidgetParams
) => {
  return (
    currentParams.isNeedPrekeridge !== defaultParams.isNeedPrekeridge ||
    currentParams.isNeedContainerRent !== defaultParams.isNeedContainerRent ||
    currentParams.isWithoutPrekeridge !== defaultParams.isWithoutPrekeridge ||
    currentParams.isWithoutOnkeridge !== defaultParams.isWithoutOnkeridge ||
    currentParams.isFromTerminalRadius !== defaultParams.isFromTerminalRadius ||
    currentParams.isToTerminalRadius !== defaultParams.isToTerminalRadius ||
    currentParams.isWithCrossDocking !== defaultParams.isWithCrossDocking
  );
};
